import HorizontalCard from './HorizontalCard';

export default HorizontalCard;